<!-- Sizes XL - menu is always visible -->
@if (client.sizeId > 1) {
<ul class="menu-component"
    [ngClass]="[component.color || '', component.text_style || '']">
    @for (item of component.menu; track $index) {
    <li>
        <!-- link -->
        <div [class.m-l-2]="item.indent">
            <href [link]="item.link">
                <p class="p-a-2"
                   [ngClass]="{'bg-col-5': isCurrent(item.link)}"
                   *iCms="'text' of item"></p>
            </href>
        </div>
    </li>
    }
</ul>
} @else {
<!-- Size SM - menu uses toggle -->
<div class="w-12 flex flex-middle flex-justify-center p-a-3 b-l b-t b-r"
     [toggle]="['toggle_mobile_menu', 0]">
    <i class="icon-nav">
        <span></span>
        <span></span>
        <span></span>
    </i>
    <p class="m-l-2">{{'Menu' | translate}}</p>
</div>
<div class="b-l b-r b-b"
     [hideUp]="['toggle_mobile_menu', 0]">
    @for (item of component.menu; track $index) {
    <div class="link p-b-2 p-t-2 center"
         [ngClass]="{
                    'b-t': $first,
                    'b-b': !$last,
                    'bg-col-5': item.link === meta.state?.url
                }">
        <href [link]="item.link">
            <p class="p1"
               *iCms="'text' of item"></p>
        </href>
    </div>
    }
</div>
}